import {
  Box,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import type { FunctionComponent } from "react";

type DeltaELabelProps = {};

const DeltaELabel: FunctionComponent<DeltaELabelProps> = (_props) => {
  const theme = useTheme();

  return (
    <Typography fontSize="inherit" fontWeight="inherit">
      ΔE
      <Tooltip
        arrow={true}
        title={
          <Box padding={1}>
            <Typography fontWeight={500}>
              Color Difference ΔE*<sub>00</sub>
            </Typography>
            <p>
              Delta E, often written as dE or ΔE, is a measure for the perceived
              color distance (color difference), which is "equally spaced" for
              all occurring colors, if possible.
            </p>
            <List dense disablePadding>
              <ListItem disableGutters>
                <ListItemText>0.0 - 0.5</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  almost imperceptible
                </Box>
              </ListItem>
              <ListItem disableGutters>
                <ListItemText>0.5 - 1.0</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  noticeable to the trained eye
                </Box>
              </ListItem>
              <ListItem disableGutters>
                <ListItemText>1.0 - 2.0</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  slight color difference
                </Box>
              </ListItem>
              <ListItem disableGutters>
                <ListItemText>2.0 - 4.0</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  perceived color difference
                </Box>
              </ListItem>
              <ListItem disableGutters>
                <ListItemText>4.0 - 5.0</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  significant, rarely tolerated color difference
                </Box>
              </ListItem>
              <ListItem disableGutters>
                <ListItemText>&gt; 5.0</ListItemText>
                <Box textAlign="right" maxWidth="70%">
                  the difference is evaluated as a different color
                </Box>
              </ListItem>
            </List>
          </Box>
        }
      >
        <Typography
          ml={0.25}
          component="span"
          sx={{
            textDecoration: "underline",
            textDecorationColor: theme.palette.text.secondary,
          }}
          fontSize="0.8em"
          fontWeight="inherit"
        >
          ?
        </Typography>
      </Tooltip>
    </Typography>
  );
};

export default DeltaELabel;
